/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-07-27 15:01:21
 * @LastEditTime: 2022-03-14 16:02:04
 */
import { post } from '../utils/request.js';
import { Dialog } from 'vant';
import {inputInstallCountValidate, installCountValidate} from 'src/config/constant.config'
import _ from 'lodash';
/**
 * @Date: 2021-07-27 15:01:54
 * @LastEditTime:
 * @description: 获取国家和地区
 * @param {*}
 * @return {*}
 */
export const getCountry = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    console.error('getCountry', error);
    return Promise.resolve(null);
  }
};
export const formatTime = (inputTime, sec) =>{
  if (!inputTime) return ''
  const date = new Date(sec ? inputTime * 1000 : inputTime)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? ('0' + minute) : minute
  second = second < 10 ? ('0' + second) : second
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
}
export const getWordRank = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    console.error('getWordRank', error);
    return Promise.resolve(null);
  }
};
export const getReview = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    console.error('getReview', error);
    return Promise.resolve(null);
  }
};
export const getWordRankRefresh = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    console.error('getWordRankRefresh', error);
    return Promise.resolve(null);
  }
};
export const getListWords = async(url, params = null) => {
  try {
    const res = await post(url, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

export const formDatetoTs = (dateTime, type) => {
  if (!dateTime) return null
  if (dateTime) {
    if (type === 1) {
      return dateTime[0].getTime().valueOf()
    } else {
      return dateTime.length > 1 ? dateTime[1].getTime().valueOf() : null
    }
  }
}
export const sortWord=(obj)=>{
  let keys = Object.keys(obj).sort(),
    sortedObj = {};

  for (var i in keys) {
    sortedObj[keys[i]] = obj[keys[i]];
  }

  return sortedObj;
}

export const getMonthWord=(month)=>{
  let monthWord=''
  switch(month){
    case 1:
      monthWord='January'
      break;
    case 2:
      monthWord='February'
      break;
    case 3:
      monthWord='March'
      break;
    case 4:
      monthWord='April'
      break;
    case 5:
      monthWord='May'
      break;
    case 6:
      monthWord='June'
      break;
    case 7:
      monthWord='July'
      break;
    case 8:
      monthWord='August'
      break;
    case 9:
      monthWord='September'
      break;
    case 10:
      monthWord='October'
      break;
    case 11:
      monthWord='November'
      break;
    case 12:
      monthWord='December'
      break;
  }
  return monthWord
}
export const configData = [
  {
    title: 'Smart Campaign',
    url: 'images/home/smartCampaign.svg',
    type: 'SMART_CAMPAIGN',
    borderColor: '#1DC8A1',
    act: 6
  },
  {
    title: 'Package (Direct) Installs',
    url: 'images/home/install.svg',
    type: 'DIRECT_INSTALL',
    borderColor: '#1DC8A1',
    act: 1
  },
  {
    title: 'Keyword Installs',
    url: `images/home/keyword.svg`,
    type: 'KEYWORD_INSTALL',
    borderColor: '#1CBBCD',
    act: 2
  },
  {
    title: 'Guaranteed Keyword Ranking',
    url: 'images/home/keep.svg',
    type: 'ASO',
    borderColor: '#148CFC',
    newTag: true,
    act: 7
  },
  {
    title: 'Guaranteed Reviews Service',
    url: 'images/home/guaranteed.svg',
    type: 'GUARANTEED_REVIEWS',
    borderColor: '#6153ff',
    newTag: true,
    act: 9
  },
  {
    title: 'Ratings',
    url: 'images/home/rating.svg',
    type: 'RATING',
    borderColor: '#FE6C4F',
    act: 3
  },
  {
    title: 'Reviews',
    url: 'images/home/reviews.svg',
    type: 'REVIEW',
    borderColor: '#FFA712',
    act: 4
  },
  {
    title: 'Advanced Campaign',
    url: 'images/home/campaign.svg',
    type: 'CAMPAIGN',
    borderColor: '#DB4EE9',
    act: 5
  },
  {
    title: 'App Review Likes Service',
    url: 'images/home/reviews-likes.svg',
    type: 'APP_REVIEWS_LIKES',
    borderColor: '#2078FF',
    newTag: true,
    act: 10
  },
  {
    title: 'Keyword Ranking Acquisition',
    url: 'images/home/acquisitionsvg.svg',
    type: 'KEYWORD_RANKING_ACQUISITION',
    borderColor: '#0BAE96',
    newTag: true,
    offFivity: true,
    act: 8
  },
  {
    title: 'Aso Service',
    url: 'images/home/aso-service-icon.svg',
    type: 'ASO_SERVICE',
    borderColor: '#F67F1E',
    newTag: true,
    act: 11
  },
  {
    title: 'Combo Package',
    url: 'images/home/install-package-icon.svg',
    type: 'INSTALLS_PACKAGE',
    borderColor: '#573FF4',
    newTag: true,
    act: 12
  },
  {
    title: 'API',
    url: 'images/home/api-service-icon.svg',
    type: 'API_SERVICES',
    borderColor: '#F8795A',
    newTag: true,
    act: 13
  },
  {
    title: 'Custom Solution',
    url: 'images/home/custom-solution.png',
    type: 'CUSTOM_ORDER',
    borderColor: '#148CFC',
    newTag: true,
    act: 13
  }
];
const checkRepeat = function(c, reviews,type=null) {
  let count = 0
  reviews.forEach(d => {
    if (d.title.trim() === c || d.content.trim() === c|| (d.reviewer&&d.reviewer.trim() === c)) {
      count++
      if (count >= 2) {
        return false
      }
    }
  })
  if (count >= 2) {
    if (type === 'website') {
      return 'Name of reviewer cannot be repeated'
    } else {
      return 'Do not repeat comments'
    }
  }
  return ''
}
const checkDay = function(list) {
  if (list.length > 14) {
    Dialog.alert({ message: `Orders are limited to a maximum of 14 days, please modify the days.` }, { showClose: false })
    return true
  }
  return false
}
export {checkDay}
export const checkOrder = async function(serviceType,list,platform,campaignType) {
  // 检查各种表单
  switch (serviceType) {
    case 'DIRECT_INSTALL': {
      if (checkDay(list)) {
        return false
      }
      for (const i of list) {
        const error = inputInstallCountValidate(i.install)
        if (error) {
          await Dialog.alert({message:`${error}`})
          return false
        }
      }
      let dayInstall = 0
      for (const i of list) {
        dayInstall = i.install
        const numError = installCountValidate(dayInstall)
        if (numError) {
          await Dialog.alert({message:`${numError}`, confirmButtonText: "Ok"})
          return false
        }
      }
      break
    }
    case 'KEYWORD_INSTALL': {
      if (checkDay(list)) {
        return false
      }
      for (const days of list) {
        for (const i of days) {
          // 检查安装数量
          const error = inputInstallCountValidate(i.install)
          if (error) {
            await Dialog.alert({message:`Install count error: ${error}`}, { showClose: false })
            return false
          }
          // 检查关键词不为空且不重复
          const w = i.word.trim()
          if (w.length === 0) {
            await Dialog.alert({message:'Keyword cannot be empty'}, { showClose: false })
            return false
          } else if (days.filter(i => w.trim().toLowerCase() ===
            i.word.trim().toLowerCase()).length > 1) {
            await Dialog.alert({message:'Keywords cannot be repeated'}, { showClose: false })
            return false
          }
          // 检查关键词已获取排名掉榜
          // if (i.rank != null && i.rank <= 0) {
          //   await Dialog.alert({message:'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us. '}, { showClose: false })
          //   return false
          // }
        }
      }
      for (const days of list) {
        let dayInstall = 0
        for (const i of days) {
          dayInstall += i.install
        }
        // 检查安装数量
        const numError = installCountValidate(dayInstall)
        if (numError) {
          await Dialog.alert({message:`${numError}`, confirmButtonText: "Ok"}, { showClose: false })
          return false
        }
      }
      break
    }
    case 'RATING': {
      if (checkDay(list)) {
        return false
      }
      for (const i of list) {
        const error = inputInstallCountValidate(i.install)
        if (error) {
          await Dialog.alert({message:`${error}`})
          return false
        }
      }
      break
    }
    case 'GUARANTEED_REVIEWS':
    case 'REVIEW': {
      if (checkDay(list)) {
        return false
      }
      if (serviceType === 'GUARANTEED_REVIEWS'&&platform===1) {
        const totalCount = _.sumBy(list, (i) => {
          if (i.isNull) {
            return 0
          }
          return i.review.length
        })
        if (totalCount < 10) {
          await Dialog.alert({message:'The minimum number of your reviews is 10.'})
          return false
        }
      }
      for (const days of list) {
        if (days.isNull) {
          continue;
        }
        let daysList = days.review
        for (const i of daysList) {
          if (platform === 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Title cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({message:repeat})
                return false
              }
            }

            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
            if(serviceType === 'GUARANTEED_REVIEWS'){
              c = i.reviewer.trim()
              if(c.length>0){
                if(c.length<12){
                  await Dialog.alert({ message: `Name of reviewer is limited to 12-25 characters` }, { showClose: false })
                  return false
                }
                if(isWebsite(c)){
                  await Dialog.alert({ message: `Name of reviewer is not available` }, { showClose: false })
                  return false
                }
                const repeat = checkRepeat(c, daysList,'website')
                if (repeat) {
                  await Dialog.alert({message:repeat}, { showClose: false })
                  return false
                }
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, daysList)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
          }
        }
      }
      //save时敏感词提示逻辑
      // if(platform===2&&list.find(item=>item.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
      //   // 是否有敏感词
      //   await Dialog.alert({ message: `Reviews or titles contain the offensive word.\nPlease check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
      //   return false
      // }
      break
    }
    /*
    case 'GUARANTEED_REVIEWS': {
      if (checkDay(list)) {
        return false
      }
      if (serviceType === 'GUARANTEED_REVIEWS'&&platform===1) {
        const totalCount = _.sumBy(list, (i) => i.length)
        if (totalCount < 10) {
          await Dialog.alert({message:'The minimum number of your reviews is 10.'})
          return false
        }
      }
      for (const days of list) {
        for (const i of days) {
          if (platform === 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Title cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({message:repeat})
                return false
              }
            }

            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
            if(serviceType === 'GUARANTEED_REVIEWS'){
              c = i.reviewer.trim()
              if(c.length>0){
                if(c.length<12){
                  await Dialog.alert({ message: `Name of reviewer is limited to 12-25 characters` }, { showClose: false })
                  return false
                }
                if(isWebsite(c)){
                  await Dialog.alert({ message: `Name of reviewer is not available` }, { showClose: false })
                  return false
                }
                const repeat = checkRepeat(c, days,'website')
                if (repeat) {
                  await Dialog.alert({message:repeat}, { showClose: false })
                  return false
                }
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
          }
        }
      }
      //save时敏感词提示逻辑
      // if(platform===2&&list.find(item=>item.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
      //   // 是否有敏感词
      //   await Dialog.alert({ message: `Reviews or titles contain the offensive word.\nPlease check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
      //   return false
      // }
      break
    }
    */
    case 'ASO': {
      //let skipOutCheck = false // 如果用户第一次选择了对out的词继续提交，则后续都需要跳过out检查
      for (const i of list) {
        // 检查关键词不为空且不重复
        const w = i.word.trim()
        if (w.length === 0) {
          await Dialog.alert({
            message:'Keyword cannot be empty'
          }, { showClose: false })
          return false
        } else if (list.filter(
          i => w.trim().toLowerCase() ===
            i.word.trim().toLowerCase()).length > 1) {
          await Dialog.alert({message:'Keywords cannot be repeated'}, { showClose: false })
          return false
        }
        // 检查关键词已获取排名掉榜
        // if (!skipOutCheck && i.rank != null && i.rank <= 0) {
        //   try {
        //     await Dialog.confirm({
        //       message:'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us.'
        //     },{
        //       confirmButtonText: 'Continue Submit',
        //       cancelButtonText: 'Cancel'
        //     })
        //     skipOutCheck = true
        //   } catch (e) {
        //     return false
        //   }
        // }
      }
      break
    }
    case 'CAMPAIGN':
    case 'INSTALLS_PACKAGE': {
      const installsPerDay = [] // 每天的安装数量，用于后续检查
      if (checkDay(list)) {
        return false
      }
      if (campaignType === 'PACKAGE') {
        // 检查package install 数量正确
        for (const i of list) {
          installsPerDay.push(i.packageInstall)
          const error = inputInstallCountValidate(i.packageInstall)
          if (error) {
            await Dialog.alert({
              message:`${error}`
            }, { showClose: false })
            return false
          }
        }
        if(serviceType === 'CAMPAIGN'){
          let dayInstall = 0
          for (const i of list) {
            dayInstall = i.packageInstall
            const numError = installCountValidate(dayInstall)
            if (numError) {
              await Dialog.alert({
                message:`${numError}`, confirmButtonText: "Ok"
              }, { showClose: false })
              return false
            }
          }
        }
      } else if (campaignType === 'KEYWORD') {
        // 检查每天关键词不重复，且数量正确
        for (const days of list) {
          let installToday = 0
          for (const i of days.words) {
            // 检查安装数量
            const error = inputInstallCountValidate(i.install)
            if (error) {
              await Dialog.alert({message:`Install count error: ${error}`}, { showClose: false })
              return false
            }
            installToday += i.install
            // 检查关键词不为空且不重复
            const w = i.word.trim()
            if (w.length === 0) {
              await Dialog.alert({message:'Keyword cannot be empty'}, { showClose: false })
              return false
            } else if (days.words.filter(i => w.trim().toLowerCase() ===
              i.word.trim().toLowerCase()).length > 1) {
              await Dialog.alert({message:'Keywords cannot be repeated'}, { showClose: false })
              return false
            }
            // 检查关键词已获取排名掉榜
            if (i.rank != null && i.rank <= 0 && platform===2) {
              await Dialog.alert({message:'OUT: Your app can\'t be found by our users for this keyword. Please change another one or contact us. '}, { showClose: false })
              return false
            }
          }
          installsPerDay.push(installToday)
        }
        if(serviceType === 'CAMPAIGN'){
          for (const days of list) {
            let dayInstall = 0
            for (const i of days.words) {
              dayInstall += parseInt(i.install)
            }
            // 检查安装数量
            const numError = installCountValidate(dayInstall)
            if (numError) {
              await Dialog.alert({message:`${numError}`, confirmButtonText: "Ok"}, { showClose: false })
              return false
            }
          }
        }
      }
      // 检查每天评分数量合法且小于安装数
      let index = 0
      for (const i of list) {
        const error = inputInstallCountValidate(parseInt(i.rating), -1)
        if (error) {
          await Dialog.alert({message:`${error}`, showClose: false })
          return false
        }
        if (parseInt(i.rating) > installsPerDay[index]) {
          await Dialog.alert({message:`The number of ratings must be less than or equal to the number of installs`}, { showClose: false })
          return false
        }
        index++
      }
      // 检查每天评论数量小于评分数量
      for (const i of list) {
        if (i.reviews.length > parseInt(i.rating)) {
          await Dialog.alert({message:`The number of reviews must be less than or equal to the number of ratings`}, { showClose: false })
          return false
        }
      }
      // 检查每天评语不重复
      for (const days of list) {
        for (const i of days.reviews) {
          if (platform === 2) {
            let c = i.title.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Title cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }

            c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
            if (serviceType === 'INSTALLS_PACKAGE') {
              c = i.reviewer.trim()
              if ((c.length>0&&c.length < 12)||c.length>25) { 
                await Dialog.alert({message:`Name of reviewer is limited to 12-25 characters`}, { showClose: false })
                return false
              }
              if (c.length>0&&isWebsite(c)) {
                await Dialog.alert({message:`Name of reviewer is not available`}, { showClose: false })
                return false
              }
              const repeat = checkRepeat(c, days.reviews,'website')
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
          } else {
            const c = i.content.trim()
            if (c.length === 0) {
              await Dialog.alert({message:`Content cannot be empty`}, { showClose: false })
              return false
            } else {
              const repeat = checkRepeat(c, days.reviews)
              if (repeat) {
                await Dialog.alert({message:repeat}, { showClose: false })
                return false
              }
            }
          }
        }
      }
      //save时敏感词提示逻辑
      // if(platform===2&&list.find(item=>item.find(childItem=>childItem.isTitleSensitive||childItem.isContentSensitive))){
      //   // 是否有敏感词
      //   await Dialog.alert({ message: `Reviews or titles contain the offensive word.\nPlease check and modify, otherwise it will not be displayed in the App Store.`,messageAlign:'left' })
      //   return false
      // }
      // 对于gp，评分/安装，评论/安装小于一定值，强制弹出确认条款
      // if (platform === 1 && totalRating / totalInstall > 0.15 || totalReviews / totalInstall > 0.05) {
      //   if (ctx.termsDialog) {
      //     try {
      //       await ctx.termsDialog()
      //     } catch (e) {
      //       return
      //     }
      //   }
      // }
      // // 对于ios，目前需要对有评分评论的弹出框确认
      // if (platform === 2 && totalRating > 0) {
      //   if (ctx.termsDialog) {
      //     try {
      //       await ctx.termsDialog()
      //     } catch (e) {
      //       return
      //     }
      //   }
      // }
      break
    }
  }
  return true
}
export{checkRepeat} 

export const formatDiff = function(data, state) {
  const obj = {
    diff: '',
    className: 'ranking-text'
  }
  if (data > 0) {
    obj.diff = state !== 0 ? ' (+' + data + ')' : ''
    obj.className = 'ranking-plus'
  } else if (data < 0) {
    obj.diff = state !== 0 ? ' (' + data + ')' : ''
    obj.className = 'ranking-minus'
  } else if (data === 'out') {
    obj.diff = 'out'
    obj.className = 'ranking-error'
  }
  return obj
}
// 获取当前端口号
export const getClientHost = function(type) {
  return location[type]
}
export const formatTimeString = function(time) {
  if (!time) return ''
  const date = new Date(time)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d
}

export const enFormatDate=(millinSeconds)=> {
  var date = new Date(millinSeconds)
  var monthArr = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  var year = date.getFullYear() // 年
  var month = monthArr[date.getMonth()] // 月
  var ddate = date.getDate() // 日
  var days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
  var dayOfWeek = days[date.getDay()] // 星期
  return dayOfWeek + ' ' + month + ' ' + ddate + ',' + year
}

export const enFormatDateHome = function(data, showYear = false) {
  const date = new Date(data)
  const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const year = date.getFullYear() // year
  const month = monthArr[date.getMonth()] // 月
  const day = date.getDate() // 日
  let ret = month + ' ' + day+','
  if (showYear) {
    ret += ' ' + year
  }
  return ret
}
export const formatTableData = (data) => {
  data.forEach((item) => {
    // 如果是草稿状态，补齐progress字段
    if (item.state === 0) {
      item['progress'] = {
        words: {},
        ratingFinish: 0,
        reviewFinish: 0,
        lReviewFinish: 0
      }
    }
    // 转换订单类型
    // 计算install和FinishInstall
    item.totalInstall = 0
    item.finishInstall = 0
    item.totalDays = 0
    switch (item.submitType) {
      case 'PACKAGE':
        item.taskType = 'Package'
        item.days.forEach((day) => {
          day.forEach((word) => {
            item.totalInstall += word.count
          })
        })
        for (const w in item.progress.words) {
          item.finishInstall += item.progress.words[w].finish
        }
        item.totalDays = item.days.length
        break
      case 'KEYWORD':
        item.taskType = 'Keyword'
        item.days.forEach((day) => {
          day.forEach((word) => {
            item.totalInstall += word.count
          })
        })
        for (const w in item.progress.words) {
          item.finishInstall += item.progress.words[w].finish
        }
        item.totalDays = item.days.length
        break
      case 'RATE':
        item.taskType = 'Rating'
        item.totalInstall = _.sum(item.rates)
        item.finishInstall = item.progress['ratingFinish']
        item.totalDays = item.rates.length
        break
      case 'REVIEW':
      case 'GREVIEW':
        item.taskType = item.submitType === 'GREVIEW' ? 'Guaranteed Reviews' : 'Review'
        item.totalInstall = _.sum(item.reviewCount)
        item.finishInstall = item.progress['reviewFinish']
        item.totalDays = item.reviewCount.length
        break
      case 'LREVIEW':
        // 获取like相关的数据，并作相应处理
        item.taskType = 'App Review Likes'
        item.totalInstall = _.sum(item.lReviews)
        item.finishInstall = item.progress['lReviewFinish'] ? item.progress['lReviewFinish'] : 0
        item.totalDays = item.lReviews.length
        break
      default:
        item.taskType = item.submitType==='SMART'?'Smart Campaign':'Campaign'
        item.days.forEach((day) => {
          day.forEach((word) => {
            item.totalInstall += word.count
          })
        })
        for (const w in item.progress.words) {
          item.finishInstall += item.progress.words[w].finish
        }
        item.totalDays = item.days.length
        break
    }
    item.percentage = Math.floor(
      (item.finishInstall / item.totalInstall) * 100
    )
    // 只针对组合订单
    if (item.submitType === 'COMPOSITE' && item.platform === 2) {
      item.percentage = Math.floor(((item.cost / 100).toFixed(2) / (item.orderPrice / 100).toFixed(2)) * 100)
    }
    if (!item.percentage) {
      item.percentage = 0
    }
    // 事先组织好Total和Finish数据
    item.wordsTotalFinishs = []
    item.packageTotalFinish = { total: 0, finish: 0 }
    item.ratingTotalFinish = { total: 0, finish: 0 }
    item.reviewTotalFinish = { total: 0, finish: 0 }
    item.keywordTotalFinish = { total: 0, finish: 0 }
    item.likeTotalFinish = { total: 0, finish: 0 }

    const wordMap = {}
    // 统计package和各word的总数
    item.days.forEach((d) => {
      d.forEach((w) => {
        if (w.word === 'PACKAGE') {
          item.packageTotalFinish.total += w.count
        } else {
          if (wordMap[w.word] === undefined) {
            wordMap[w.word] = { total: w.count, finish: 0 }
          } else {
            wordMap[w.word].total += w.count
          }
        }
      })
    })
    // rating total
    if (item.rates) {
      item.ratingTotalFinish.total = _.sum(item.rates)
    }
    // review total
    if (item.reviewCount) {
      item.reviewTotalFinish.total = _.sum(item.reviewCount)
    }
    // like total
    if (item.lReviews) {
      item.likeTotalFinish.total = _.sum(item.lReviews)
    }
    // finish
    if (item.progress) {
      for (const k in item.progress.words) {
        if (k === 'PACKAGE') {
          item.packageTotalFinish.finish = item.progress.words[k].finish
        } else {
          wordMap[k].finish = item.progress.words[k].finish
        }
      }
      item.ratingTotalFinish.finish = item.progress.ratingFinish
      item.reviewTotalFinish.finish = item.progress.reviewFinish
      item.likeTotalFinish.finish = item.progress.lReviewFinish ? item.progress.lReviewFinish : 0// 点赞
    }
    for (const k in wordMap) {
      item.keywordTotalFinish.total += wordMap[k].total
      item.keywordTotalFinish.finish += wordMap[k].finish
      item.wordsTotalFinishs.push({
        word: k,
        total: wordMap[k].total,
        finish: wordMap[k].finish,
        ts: 0,
        compareTs: item.startTime ? item.startTime : 0,
        rank: 0,
        platform: item.platform,
        region: item.region,
        appId: item.appId,
        loading: true,
      })
    }
  })
  return data
}
//对关键词覆盖数据处理
export const formatKeywords = (list)=>{
  if (Array.isArray(list) && !list.length) return list
  list.forEach((item) => {
    const word = item.wordList
    item.taskType='Keyword Ranking Acquisition'
    Array.isArray(word) && !!word.length && (item.cost = _.sumBy(word, (item) => item.cost)) || (item.cost = 0)
    Array.isArray(word) && !!word.length && (item.amount =_.sumBy(word, (item) => item.price)) || (item.amount = 0)
  })
  return list
}

export const reviewLanguages = {
  AE: 'Arabic',
  BR_ES: 'Spanish',
  BR: 'Portuguese',
  CH: 'English',
  CH_DE: 'German',
  CH_FR: 'French',
  DE: 'German',
  DE_EN: 'English',
  ES: 'Spanish',
  FR: 'French',
  GB: 'English',
  HK_EN: 'English',
  HK_YUE: 'Cantonese',
  HK_ZH: 'Simplified Chinese',
  HK: 'Traditional Chinese',
  IN_EN: 'English',
  IN: 'Hindi',
  SM_IT: 'Italian',
  IR_FA: 'Farsi',
  JP: 'Japanese',
  KR: 'Korean',
  NL: 'Dutch',
  NL_EN: 'English',
  NP: 'Nepali',
  MX: 'Spanish',
  RU: 'Russian',
  SA: 'Arabic',
  SG_EN: 'English',
  SG_ZH: 'Simplified Chinese',
  TR: 'Turkish',
  TH: 'Thai',
  VN: 'Vietnamese'
}

export const regionSupportLanguages = {
  AE: ['AE'],
  BR: ['BR_ES', 'BR'],
  CH: ['CH', 'CH_DE', 'CH_FR'],
  DE: ['DE', 'DE_EN'],
  ES: ['ES'],
  FR: ['FR'],
  GB: ['GB'],
  HK: ['HK_EN', 'HK_YUE', 'HK_ZH', 'HK'],
  IN: ['IN_EN', 'IN'],
  SM: ['SM_IT'],
  IR: ['IR_FA'],
  JP: ['JP'],
  KR: ['KR'],
  NL: ['NL', 'NL_EN'],
  NP: ['NP'],
  MX: ['MX'],
  RU: ['RU'],
  SA: ['SA'],
  SG: ['SG_EN', 'SG_ZH'],
  TR: ['TR'],
  TH: ['TH'],
  VN: ['VN']
}

export function languageForRegion(region) {
  const regionCodes = regionSupportLanguages[region]
  const ret = []
  if (regionCodes) {
    regionCodes.forEach(i => {
      ret.push({
        value: i,
        label: reviewLanguages[i]
      })
    })
  }
  return ret
}
//判断是否是一个网址
export function isWebsite(str) {
  var reg = /^(https?:\/\/)?[\w\-_]+(\.[\w\-_]+)*(\w*\.(?:com\.cn|cn|com|net|org|jp|uk|fr|au|de))[\\/]*$/
  return reg.test(str.toLowerCase())
}

// 敏感词校验
export const sensitiveWordCheck=async(row, type,store)=> {
  let attr = ''// 此处表示是title还是content的敏感词表示符的名字

  let content = ''// 内容，这里指的是title或者content的内容
  let switchWords = ''// 敏感词替换后的词
  let newValue = ''
  let oldValue=''

  if (type === 'title') {
    content = row?.title
    attr = 'isTitleSensitive'
    switchWords = 'titleSwitchWords'
    newValue = 'newTitleValue'
    oldValue='oldTitleValue'
  } else {
    content = row?.content
    attr = 'isContentSensitive'
    switchWords = 'contentSwitchWords'
    newValue = 'newContentValue'
    oldValue='oldContentValue'
  }
  if (content && content.trim() && (store.state.dashboard.app.platform === 2 || store.state.dashboard.app.platform === 3)) {
    const res = await post('/MyOrder/checkIosReview', {
      review: content,
      region: store.state.dashboard.app.region
    })
    if (res&&res.data) {
      let oldValueArray=[]
      let newValueArray=[]
      if (res.data?.blackWords && res.data?.blackWords.length||res.data.regexFlag) {
        if(res.data?.blackWords?.length){
          res.data.blackWords.forEach((item) => {
            oldValueArray.push(item.oldValue)
            newValueArray.push(item.newValue)
          })
          row[newValue]=newValueArray
          row[oldValue]=oldValueArray
        }
        row[attr]=true
      } else {
        row[attr]=false
        row[newValue]=[]
        row[oldValue]=[]
      }
      row[switchWords]=res.data.review
    }
  }
}
//替换敏感词
export const switchWords=async($event, tab)=> {
  tab.forEach(item=>{
    item.title=item.titleSwitchWords
    item.isTitleSensitive=false
    item.content=item.contentSwitchWords
    item.isContentSensitive=false
    
  })
}
// 判断是否是移动端
export const isMobile=async()=> {
  const rect = document.body.getBoundingClientRect()
  return (rect.width < 1400 || rect.width < rect.height)
}

// 下单页操作埋点
export const serviceTrack=async (op, store,operationType = 'CLICK')=>{
  await store.dispatch('user/dataTrack', {
    id: window.$mine.id,
    modules: 'SERVICES',
    clickTime: new Date().getTime(),
    serviceName: getTrackServiceName(store.state.dashboard.serviceType),
    operationType: operationType,
    op: op,
    deviceType: isMobile() ? 2 : 1,
    url: '/wap/campaign'
  })
}
// 根据type获取op
export const getTrackOpName=(type)=>{
  switch (type) {
    case 'DIRECT_INSTALL':
      return 'package_installs'
    case 'KEYWORD_INSTALL':
      return 'keyword_installs'
    case 'RATING':
      return 'ratings'
    case 'REVIEW':
      return 'reviews'
    case 'CAMPAIGN':
      return 'advanced_campaign'
    case 'SMART_CAMPAIGN':
      return 'smart_campaign'
    case 'ASO':
      return 'guaranteed_keyword_ranking'
    case 'KEYWORD_RANKING_ACQUISITION':
      return 'keyword_ranking_acquisition'
    case 'GUARANTEED_REVIEWS':
      return 'guaranteed_reviews_service'
    case 'ASO_SERVICE':
      return 'aso_service'
    case 'INSTALLS_PACKAGE':
      return 'combo_package'
    case 'APP_REVIEWS_LIKES':
      return 'app_review_likes'
    case 'CUSTOM_ORDER':
      return 'custom_solution'
  }
}
//根据servicetype获取serviceName
export const getTrackServiceName=(type)=>{
  switch (type) {
    case 'DIRECT_INSTALL':
      return 'PACKAGE'
    case 'KEYWORD_INSTALL':
      return 'KEYWORD'
    case 'RATING':
      return 'RATE'
    case 'REVIEW':
      return 'REVIEW'
    case 'CAMPAIGN':
      return 'COMPOSITE'
    case 'SMART_CAMPAIGN':
      return 'SMART_CAMPAIGN'
    case 'ASO':
      return 'GUARANTEE'
    case 'KEYWORD_RANKING_ACQUISITION':
      return 'KEYWORD_ACQU'
    case 'GUARANTEED_REVIEWS':
      return 'GUARANTEE_REVIEW'
    case 'ASO_SERVICE':
      return 'ASO_SERVICE'
    case 'INSTALLS_PACKAGE':
      return 'INSTALLS_PACKAGE'
    case 'APP_REVIEWS_LIKES':
      return 'LREVIEW'
    case 'CUSTOM_ORDER':
      return 'CUSTOM_ORDER'
  }
}
export const $formatTimeFull = (timestampMill, fmt = 'yyyy-MM-dd hh:mm:ss.S')=> {
  const date = new Date(timestampMill)
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

//优惠卷服务信息
export function PromoCodeServiceFunction () {

  const typeListReSub = {
    'PACKAGE': 'DIRECT_INSTALL',
    'KEYWORD': 'KEYWORD_INSTALL',
    'RATE': 'RATING',
    'REVIEW': 'REVIEW',
    'GREVIEW': 'GOOD_REVIEW',
    'COMPOSITE': 'CAMPAIGN',
    'SMART': 'SMART_CAMPAIGN',
    'INSTALLS': 'INSTALLS_PACKAGE'
  }

  const typeListRe = {
    'PACKAGE': 'Package (Direct) Installs',
    'KEYWORD': 'Keyword Installs',
    'RATE': 'Ratings',
    'REVIEW': 'Reviews',
    'GREVIEW': 'Guaranteed Reviews Service',
    'COMPOSITE': 'Advanced Campaign',
    'SMART': 'Smart Campaign',
    'INSTALLS': 'Combo Package',
    'KEYWORD_RANKING_ACQUISITION': 'Keyword Ranking Acquisition',
  }

  const status = {
    'EXPIRE': 'The promo code has expired.',
    'REACH_LIMIT': 'The code usage limit has been reached.',
    'BAD_PRICE': 'The Promo code does not meet the requirements for the use.',
    'INVALID': 'Invalid promo code.',
  }

  const refObjectList = {
    'DIRECT_INSTALL': 'PackRef',
    'KEYWORD_INSTALL': 'KeywordRef',
    'RATING': 'RatingRef',
    'REVIEW': 'ReviewRef',
    'CAMPAIGN': 'CampaignRef',
    'SMART_CAMPAIGN': 'SCampaignRef',
    'KEYWORD_RANKING_ACQUISITION': 'KRARef',
    'GUARANTEED_REVIEWS': 'GRRef',
    'ASO_SERVICE': 'ASOServiceRef',
    'INSTALLS_PACKAGE': 'InstallRef',
    'API_SERVICES': 'ApiRef',
  }

  const typeList = [
    {
      label: 'Package(Direct) Installs',
      labelForType: 'DIRECT_INSTALL',
      value: 1
    }, {
      label: 'Keyword Installs',
      labelForType: 'KEYWORD_INSTALL',
      value: 2
    }, {
      label: 'Ratings',
      labelForType: 'RATING',
      value: 3
    }, {
      label: 'Reviews',
      labelForType: 'REVIEW',
      value: 4
    }, {
      label: 'Advanced Campaign',
      labelForType: 'CAMPAIGN',
      value: 5
    }, {
      label: 'Smart Campaign',
      labelForType: 'SMART_CAMPAIGN',
      value: 6
    }, {
      label: 'Keyword Ranking Acquisition',
      labelForType: 'KEYWORD_RANKING_ACQUISITION',
      value: 7
    }, {
      label: 'Guaranteed Reviews Service',
      labelForType: 'GUARANTEED_REVIEWS',
      value: 8
    }, {
      label: 'ASO Service',
      labelForType: 'ASO_SERVICE',
      value: 9
    }, {
      label: 'Combo Package',
      labelForType: 'INSTALLS_PACKAGE',
      value: 10
    }, {
      label: 'API',
      labelForType: 'API_SERVICES',
      value: 11
    }, {
      label: 'Ai Reviews',
      labelForType: 'AI_GENERATE_REVIEWS',
      value: 12
    }, {
      label: 'Custom Solution',
      labelForType: 'CUSTOM_ORDER',
      value: 13
    }
  ]

  function typeListToString(type, list) {
    if(type ===2 && list){
      const newList = list.sort((a,b) => a-b)
      let str = new Array()
      newList.forEach((e) => {
        str.push(typeList[e-1].label)
      })
      return str.join(', ')
    } else {
      return 'Add Money'
    }
  }

  function findTypeForList(type) {
    for(let i = 0; i < typeList.length; i++){
      if(type === typeList[i].labelForType){
        return typeList[i].value
      }
    }
  }

  // TODO:  无奈之举。日后有机会优化 !!!!
  function orderConsumption(type, row) {
    let conArr = []
    let allPrice;
    switch (type) {
      case 'PACKAGE':
      case 'KEYWORD':
      case 'GREVIEW': {
        // ! 计算 价格
        let obj = {
          label: typeListRe[row.submitType],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        conArr.push(obj)
        // ! 通过累加器计算总的价格
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
      case 'RATE': {
        let packageCon = {
          label: typeListRe['PACKAGE'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          deduct: 0,
        }
        let rateCon = {
          label: typeListRe[row.submitType],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        conArr = [packageCon, rateCon]
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
      case 'REVIEW': {
        let packageCon = {
          label: typeListRe['PACKAGE'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          deduct: 0,
        }
        let rateCon = {
          label: typeListRe['RATE'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          deduct: 0,
        }
        let reviewCon = {
          label: typeListRe[row.submitType],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub[row.submitType]] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        conArr = [packageCon, rateCon, reviewCon]
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
      case 'COMPOSITE': {
        let installCon = row.days[0][0].word === "PACKAGE" ? {
          label: typeListRe['PACKAGE'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['PACKAGE']] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        } : {
          label: typeListRe['KEYWORD'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['KEYWORD']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['KEYWORD']] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        let rateCon = {
          label: typeListRe['RATE'],
          total: row.rates.reduce((a,b)=>a+b),
          price: (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          totalPrice: row.rates.reduce((a,b)=>a+b) * (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          deduct: 0,
        }
        let reviewCon = {
          label: typeListRe['REVIEW'],
          total: row.reviewCount.reduce((a,b)=>a+b),
          price: (row.nowPrice[typeListReSub['REVIEW']] / 100).toFixed(2),
          totalPrice: row.reviewCount.reduce((a,b)=>a+b) * (row.nowPrice[typeListReSub['REVIEW']] / 100).toFixed(2),
          deduct: 0,
        }
        conArr = [installCon, rateCon, reviewCon]
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
      case 'SMART': {
        let installCon = {
          label: typeListRe['KEYWORD'],
          total: row.totalInstall,
          price: (row.nowPrice[typeListReSub['KEYWORD']] / 100).toFixed(2),
          totalPrice: row.totalInstall * (row.nowPrice[typeListReSub['KEYWORD']] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        let rateCon = {
          label: typeListRe['RATE'],
          total: row.rates.reduce((a,b)=>a+b),
          price: (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          totalPrice: row.rates.reduce((a,b)=>a+b) * (row.nowPrice[typeListReSub['RATE']] / 100).toFixed(2),
          deduct: 0,
        }
        let reviewCon = {
          label: typeListRe['REVIEW'],
          total: row.reviewCount.reduce((a,b)=>a+b),
          price: (row.nowPrice[typeListReSub['REVIEW']] / 100).toFixed(2),
          totalPrice: row.reviewCount.reduce((a,b)=>a+b) * (row.nowPrice[typeListReSub['REVIEW']] / 100).toFixed(2),
          deduct: 0,
        }
        conArr = [installCon, rateCon, reviewCon]
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
      case 'INSTALLS': {

        //!!!!!! installs package 特殊 名字相同但是价格分type 所以价格单独算 !!!!!!!!
        //!!!!!! combopackage 总数固定是 1 !!!!!!!!

        let installCon = row.installsPackageType === 1 ? {
          label: typeListRe[row.submitType],
          total: 1,
          price: (row.nowPrice['INSTALL_PACKAGE_BASE'] / 100).toFixed(2),
          totalPrice: 1 * (row.nowPrice['INSTALL_PACKAGE_BASE'] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        } : {
          label: typeListRe[row.submitType],
          total: 1,
          price: (row.nowPrice['INSTALL_PACKAGE_BASE'] / 100).toFixed(2),
          totalPrice: 1 * (row.nowPrice['INSTALL_PACKAGE_BASE'] / 100).toFixed(2),
          deduct: row.promoCodeDeduct,
        }
        conArr.push(installCon)
        allPrice = conArr.reduce((a, b, i) => {
          if(i === 0){
            return a
          }
          return a + b.totalPrice
        }, conArr[0].totalPrice)
        return {conArr, allPrice}
      }
    }
  }

  return {
    status,
    typeList,
    refObjectList,
    typeListToString,
    findTypeForList,
    orderConsumption
  }
}